export const marketPlaceCardsTranslations = {
  en: {
    marketplace_tabs: "Marketplace Tabs",
    all_cards: "All",
    my_cards: "My Cards",
    search_by_name: "Search by Name",
    select_type: "Select Type",
    reset_filters: "Reset Filters",
    no_cards_found: "No Cards Found",
    no_cards_description: "Try changing your filter or search term.",
    manager: "Manager",
    athlete: "Athlete",
    organization: "Organization",
    select_location: "Location",
    select_sport: "Fighting discipline",
    select_weight_class: "Weight class",
    select_purse: "Purse options",
    title_holder_placeholder: "Title Holder",
    select_roster_status: "Select Roster Status",
    select_opportunity_type: "Select Opportunity Type",
    create_card: "Create ReadyRoster Card",
    create_opportunity: "Create Opportunity",
    choose_template: "Choose a Template",
    make_a_deal: "Make a Deal",
    document_requirement: "Document Requirement",
    document_type: "Document Type",
    submission_deadline: "Submission Deadline",
    additional_notes_optional: "Additional Notes (optional)",
    upload_status: "Upload Status",
    uploaded_document: "Uploaded Document",
    pending_upload: "Pending Upload",
    deadline_missed: "Deadline Missed",
    select_template_to_preview: "Select a template to preview and fill in details",
    template_selected: "{{name}} selected",
    template_available: "{{count}} template available",
    templates_available: "{{count}} templates available",
    steps_count: "{{count}} steps",
    no_templates_available: "No templates available",
    deal_wizard: "Deal wizard",
    deal_wizard_desc: "Select the contract type template. Each template includes an automatically generated, legally valid PDF, as well as clearly defined timeframes for both parties.",
    template_steps_label: "Template has {{count}} steps as shown below:",
    contract_progress_label: "Contract progress",
    start: "Start",
    loading: "Loading...",
    failed_to_load_templates: "Failed to load templates",
    failed_to_load_initial_data: "Failed to Load Initial Data",
    failed_to_load_purse_options: "Failed to Load Purse Options",
    failed_to_load_training_disciplines: "Failed to Load Training Disciplines",
    failed_to_load_currency_options: "Failed to Load Currency Options",
    failed_to_load_weight_classes: "Failed to Load Weight Classes",
    failed_to_load_opportunity_types: "Failed to Load Opportunity Types",
    failed_to_load_roster_statuses: "Failed to Load Roster Statuses",
    failed_to_load_cards: "Failed to Load Cards",
    card_published_successfully: "Card Published Successfully",
    failed_to_publish_card: "Failed to Publish Card",
    failed_to_open_edit_modal: "Failed to Open Edit Modal",
    card_deleted_successfully: "Card Deleted Successfully",
    failed_to_delete_card: "Failed to Delete Card",
    failed_to_open_view_modal: "Failed to Open View Modal",
    failed_to_open_opportunity_view: "Failed to Open Opportunity View",
    missing_sender_or_receiver: "Missing Sender or Receiver",
    contact_invite_success: "Contact Invite Sent Successfully",
    failed_to_create_contact: "Failed to Create Contact",
    edit: "Edit",
    update_details: "Update Details",
    delete: "Delete",
    sport: "Sport",
    purse: "Purse",
    weight_class: "Weight Class",
    preferred_ruleset: "Preferred Ruleset",
    location: "Location",
    valid_upto: "Valid Upto",
    event_date: "Event Date",
    confirm_delete_title: "Delete Card?",
    confirm_delete_message: "Are you sure you want to delete this card?",
    cancel: "Cancel",
    add_account: "Add Account",
    verification_pending:"Account Verification Pending",
    close: "Close",
    get_account_details: "Get Account Details",
    account_details: "Account Details",
    account_details_description: "Stripe connected account status and verification details.",
    failed_to_load_account_details: "Failed to load account details",
    status: "Status",
    verification_sub_status: "Verification Sub Status",
    account_type: "Account Type",
    bank_name: "Bank Name",
    bank_account_last4: "Bank Account",
    payouts_enabled: "Payouts Enabled",
    charges_enabled: "Charges Enabled",
    details_submitted: "Details Submitted",
    disabled_reason: "Disabled Reason",
    onboarding_url: "Onboarding URL",
    requirements_currently_due: "Requirements Currently Due",
    requirements_eventually_due: "Requirements Eventually Due",
    requirements_past_due: "Requirements Past Due",
    requirement_errors: "Requirement Errors",
    no_requirements: "No requirements",
    payment_capabilities: "Payment Capabilities",
    account_information: "Account Information",
    verification_requirements: "Verification Requirements",
    no_account_details: "No account details available",
    account_details_footer: "Use Update to refresh onboarding details in Stripe.",
    yes: "Yes",
    no: "No"
  },

  de: {
    marketplace_tabs: "Marktplatz-Registerkarten",
    all_cards: "Alle Karten",
    my_cards: "Meine Karten",
    search_by_name: "Nach Namen suchen",
    select_type: "Typ auswählen",
    reset_filters: "Filter zurücksetzen",
    no_cards_found: "Keine Karten gefunden",
    no_cards_description: "Versuche, deinen Filter oder Suchbegriff zu ändern.",
    manager: "Manager",
    athlete: "Sportler",
    organization: "Organisation",
    select_location: "Standort auswählen",
    select_sport: "Sport auswählen",
    select_weight_class: "Gewichtsklasse auswählen",
    select_purse: "Börse auswählen",
    title_holder_placeholder: "Titelträger",
    select_roster_status: "Roster-Status auswählen",
    select_opportunity_type: "Gelegenheitsart auswählen",
    create_card: "ReadyRoster-Karte anlegen",
    create_opportunity: "Gelegenheit erstellen",
    choose_template: "Vorlage auswählen",
    make_a_deal: "Einen Deal machen",
    document_requirement: "Dokumentenanforderung",
    document_type: "Dokumententyp",
    submission_deadline: "Einreichungsfrist",
    additional_notes_optional: "Zusätzliche Hinweise (optional)",
    upload_status: "Upload-Status",
    uploaded_document: "Hochgeladenes Dokument",
    pending_upload: "Upload ausstehend",
    deadline_missed: "Frist verpasst",
    select_template_to_preview: "Wähle eine Vorlage aus, um sie anzusehen und Details auszufüllen",
    template_selected: "{{name}} ausgewählt",
    template_available: "{{count}} Vorlage verfügbar",
    templates_available: "{{count}} Vorlagen verfügbar",
    steps_count: "{{count}} Schritte",
    no_templates_available: "Keine Vorlagen verfügbar",
    deal_wizard: "Deal-Assistent",
    deal_wizard_desc: "Wählen Sie die Vertragsvorlage. Jede Vorlage enthält einen automatisch generierten, rechtsgültigen PDF sowie klar definierte Fristen für beide Parteien.",
    template_steps_label: "Die Vorlage umfasst {{count}} Schritte wie unten gezeigt:",
    contract_progress_label: "Vertragsablauf",
    start: "Start",
    loading: "Laden...",
    failed_to_load_templates: "Vorlagen konnten nicht geladen werden",
    failed_to_load_initial_data: "Fehler beim Laden der initialen Daten",
    failed_to_load_purse_options: "Fehler beim Laden der Börsenoptionen",
    failed_to_load_training_disciplines: "Fehler beim Laden der Trainingsdisziplinen",
    failed_to_load_currency_options: "Fehler beim Laden der Währungsoptionen",
    failed_to_load_weight_classes: "Fehler beim Laden der Gewichtsklassen",
    failed_to_load_opportunity_types: "Fehler beim Laden der Gelegenheitsarten",
    failed_to_load_roster_statuses: "Fehler beim Laden der Roster-Status",
    failed_to_load_cards: "Fehler beim Laden der Karten",
    card_published_successfully: "Karte erfolgreich veröffentlicht",
    failed_to_publish_card: "Fehler beim Veröffentlichen der Karte",
    failed_to_open_edit_modal: "Fehler beim Öffnen des Bearbeitungsmodals",
    card_deleted_successfully: "Karte erfolgreich gelöscht",
    failed_to_delete_card: "Fehler beim Löschen der Karte",
    failed_to_open_view_modal: "Fehler beim Öffnen des Ansichtsmodals",
    failed_to_open_opportunity_view: "Fehler beim Öffnen der Gelegenheitsansicht",
    missing_sender_or_receiver: "Absender oder Empfänger fehlt",
    contact_invite_success: "Kontaktanfrage erfolgreich gesendet",
    failed_to_create_contact: "Fehler beim Erstellen des Kontakts",
    edit: "Bearbeiten",
    update_details: "Details aktualisieren",
    delete: "Löschen",
    sport: "Sportart",
    purse: "Preisgeld",
    weight_class: "Gewichtsklasse",
    preferred_ruleset: "Bevorzugtes Regelwerk",
    location: "Ort",
    valid_upto: "Gültig bis: ",
    event_date: "Veranstaltungsdatum: ",
    confirm_delete_title: "Karte löschen?",
    confirm_delete_message: "Sind Sie sicher, dass Sie diese Karte löschen möchten?",
    cancel: "Abbrechen",
    add_account:"Konto hinzufügen",
     verification_pending:"Kontoüberprüfung ausstehend",
    close: "Schliessen",
    get_account_details: "Kontodetails abrufen",
    account_details: "Kontodetails",
    account_details_description: "Status und Verifizierungsdetails des verbundenen Stripe-Kontos.",
    failed_to_load_account_details: "Kontodetails konnten nicht geladen werden",
    status: "Status",
    verification_sub_status: "Verifizierungs-Unterstatus",
    account_type: "Kontotyp",
    bank_name: "Bankname",
    bank_account_last4: "Bankkonto",
    payouts_enabled: "Auszahlungen aktiviert",
    charges_enabled: "Zahlungen aktiviert",
    details_submitted: "Details eingereicht",
    disabled_reason: "Deaktivierungsgrund",
    onboarding_url: "Onboarding-URL",
    requirements_currently_due: "Aktuell faellige Anforderungen",
    requirements_eventually_due: "Spaeter faellige Anforderungen",
    requirements_past_due: "Ueberfaellige Anforderungen",
    requirement_errors: "Anforderungsfehler",
    no_requirements: "Keine Anforderungen",
    payment_capabilities: "Zahlungsfunktionen",
    account_information: "Kontoinformationen",
    verification_requirements: "Verifizierungsanforderungen",
    no_account_details: "Keine Kontodetails verfuegbar",
    account_details_footer: "Mit Aktualisieren koennen Onboarding-Details in Stripe aktualisiert werden.",
    yes: "Ja",
    no: "Nein",
  },

  hr: {
    marketplace_tabs: "Kartice Tržišta",
    all_cards: "Sve kartice",
    my_cards: "Moje kartice",
    search_by_name: "Pretraži po imenu",
    select_type: "Odaberi vrstu",
    reset_filters: "Poništi filtre",
    no_cards_found: "Nema pronađenih kartica",
    no_cards_description: "Pokušaj promijeniti filter ili pojam pretraživanja.",
    manager: "Menadžer",
    athlete: "Sportaš",
    organization: "Organizacija",
    select_location: "Odaberi lokaciju",
    select_sport: "Odaberi sport",
    select_weight_class: "Odaberi težinsku klasu",
    select_purse: "Odaberi novčanik",
    title_holder_placeholder: "Nositelj naslova",
    select_roster_status: "Odaberi status popisa",
    select_opportunity_type: "Odaberi vrstu prilike",
    create_card: "Stvori ReadyRoster karticu",
    create_opportunity: "Stvori priliku",
    choose_template: "Odaberi predložak",
    make_a_deal: "Sklopi posao",
    document_requirement: "Zahtjev za dokument",
    document_type: "Vrsta dokumenta",
    submission_deadline: "Rok za predaju",
    additional_notes_optional: "Dodatne napomene (neobavezno)",
    upload_status: "Status učitavanja",
    uploaded_document: "Učitani dokument",
    pending_upload: "Čeka učitavanje",
    deadline_missed: "Rok propušten",
    select_template_to_preview: "Odaberi predložak za pregled i unos detalja",
    template_selected: "{{name}} odabran",
    template_available: "{{count}} predložak dostupan",
    templates_available: "{{count}} predložaka dostupno",
    steps_count: "{{count}} koraka",
    no_templates_available: "Nema dostupnih predložaka",
    deal_wizard: "Čarobnjak za dogovor",
    deal_wizard_desc: "Odaberite predložak ugovora. Svaki predložak uključuje automatski generirano, pravno valjano PDF-izvješće i jasno definirane rokove za obje strane.",
    template_steps_label: "Predložak ima {{count}} koraka kako je prikazano dolje:",
    contract_progress_label: "Tijek ugovora",
    start: "Start",
    loading: "Učitavanje...",
    failed_to_load_templates: "Učitavanje predložaka nije uspjelo",
    failed_to_load_initial_data: "Neuspješno učitavanje početnih podataka",
    failed_to_load_purse_options: "Neuspješno učitavanje opcija novčanika",
    failed_to_load_training_disciplines: "Neuspješno učitavanje trenažnih disciplina",
    failed_to_load_currency_options: "Neuspješno učitavanje opcija valute",
    failed_to_load_weight_classes: "Neuspješno učitavanje težinskih klasa",
    failed_to_load_opportunity_types: "Neuspješno učitavanje vrsta prilika",
    failed_to_load_roster_statuses: "Neuspješno učitavanje statusa popisa",
    failed_to_load_cards: "Neuspješno učitavanje kartica",
    card_published_successfully: "Kartica uspješno objavljena",
    failed_to_publish_card: "Neuspješno objavljivanje kartice",
    failed_to_open_edit_modal: "Neuspješno otvaranje moda za uređivanje",
    card_deleted_successfully: "Kartica uspješno obrisana",
    failed_to_delete_card: "Neuspješno brisanje kartice",
    failed_to_open_view_modal: "Neuspješno otvaranje moda za pregled",
    failed_to_open_opportunity_view: "Neuspješno otvaranje pregleda prilike",
    missing_sender_or_receiver: "Nedostaje pošiljatelj ili primatelj",
    contact_invite_success: "Poziv za kontakt uspješno poslan",
    failed_to_create_contact: "Neuspješno stvaranje kontakta",
    edit: "Uredi",
    update_details: "Azuriraj detalje",
    delete: "Obriši",
    sport: "Sport",
    purse: "Nagrada",
    weight_class: "Težinska kategorija",
    preferred_ruleset: "Preferirana pravila",
    location: "Lokacija",
    valid_upto: "Vrijedi do: ",
    event_date: "Datum događaja: ",
    confirm_delete_title: "Obrisati karticu?",
    confirm_delete_message: "Jeste li sigurni da želite obrisati ovu karticu?",
    get_account_details: "Dohvati detalje racuna",
    account_details: "Detalji racuna",
    account_details_description: "Status povezanog Stripe racuna i detalji verifikacije.",
    failed_to_load_account_details: "Neuspjesno ucitavanje detalja racuna",
    status: "Status",
    verification_sub_status: "Podstatus verifikacije",
    account_type: "Vrsta racuna",
    bank_name: "Naziv banke",
    bank_account_last4: "Bankovni racun",
    payouts_enabled: "Isplate omogucene",
    charges_enabled: "Naplate omogucene",
    details_submitted: "Detalji poslani",
    disabled_reason: "Razlog onemogucavanja",
    onboarding_url: "Onboarding URL",
    requirements_currently_due: "Trenutno potrebni zahtjevi",
    requirements_eventually_due: "Buduci zahtjevi",
    requirements_past_due: "Zakasnjeli zahtjevi",
    requirement_errors: "Greske zahtjeva",
    no_requirements: "Nema zahtjeva",
    payment_capabilities: "Mogucnosti placanja",
    account_information: "Informacije o racunu",
    verification_requirements: "Zahtjevi za verifikaciju",
    no_account_details: "Nema dostupnih detalja racuna",
    account_details_footer: "Koristite Azuriraj za azuriranje onboarding detalja u Stripeu.",
    yes: "Da",
    no: "Ne",
    cancel: "Odustani",
    add_account:"Dodaj račun",
     verification_pending:"Verifikacija računa na čekanju",
    close: "Zatvori",
  },
};
